/* eslint-disable import/no-default-export */
import ReactDOM from 'react-dom';
import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';

export function backToTopLauncher(options = {}) {
    const backToTopContainer = document.createElement('div');
    document.body.appendChild(backToTopContainer);

    const { showChatWidget, isCopyEnabled } = options;

    return import(
        /* webpackChunkName: "backToTop" */
        '../src/BackToTop/BackToTop'
    ).then(mod => {
        const { BackToTop } = mod;

        ReactDOM.render(
            <IntlProvider
                locale={serverVars.get('localeDataKey')}
                messages={serverVars.get('messages')}
                defaultLocale="en"
            >
                <BackToTop isCopyEnabled={isCopyEnabled} showChatWidget={showChatWidget} />
            </IntlProvider>,
            backToTopContainer
        );
    });
}
